import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//rotas do app:
import Home from '../view/Home'
import Login from '../view/Login'
import HomeFeed from '../view/HomeFeed'
import AlunoHome from '../view/AlunoHome'
import Calendar from '../view/Calendar'
import WelcomeQuiz from '../view/WelcomeQuiz'
import Profile from '../view/Profile'
import GravarTreino from '../view/GravarTreino'
import Noticias from '../view/Noticias'
import FindFriends from '../view/FindFriends'
import Eventos from '../view/Eventos'
import MeusAlunos from '../view/treinador/MeusAlunos'
import TreinosDoDia from '../view/treinador/TreinosDoDia'
import TodosOsTreinosDoDia from '../view/admin/TodosOsTreinosDoDia'
import TodosOsTreinos from '../view/admin/TodosOsTreinos'
import NovaConta from '../view/NovaConta'
import Planos from '../view/Planos'
import MinhasAssinaturas from '../view/MinhasAssinaturas'
import AlunoResumo from '../view/AlunoResumo'
import MeusAlunosResumo from '../view/treinador/MeusAlunosResumo'
import RemoverConta from '../view/RemoverConta'
import Assinatura from '../view/Assinatura.vue'
import Alunos from '../view/Alunos.vue'
import Users from '../view/Users.vue'
import ReportPage from '../view/ReportPage.vue'
import ChartPageAdmin from '../view/charts/ChartPageAdmin.vue'
import ChartPageAluno from '../view/charts/ChartPageAluno.vue'
import GlobalInsights from '../view/admin/GlobalInsights.vue'
import SpecificInsights from '../view/admin/SpecificInsights.vue'
import GivenFeedbacks from '../view/treinador/GivenFeedbacks.vue'
import DailyResume from '../view/admin/DailyResume.vue'

export default new Router({

  'mode': 'history',
  scrollBehavior: () => ({ y: 0 }),

  'routes': [

    //app routes:
    {
      'path': '/',
      'component': Home,
      'name' : 'home',
      meta: {title: 'Home'}
    },
    {
      'path': '/login',
      'component': Login,
      'name' : 'login',
      meta: {title: 'Login'}
    },
    {
      'path': '/homeFeed',
      'component': HomeFeed,
      'name' : 'homeFeed',
      meta: {title: 'Feed'}
    },
    {
      'path': '/alunoHome',
      'component': AlunoHome,
      'name' : 'alunoHome',
      meta: {title: 'Meu dia'}
    },
    {
      'path': '/calendar',
      'component': Calendar,
      'name' : 'calendar',
      meta: {title: 'Planilha'}
    },
    {
      'path': '/welcomeQuiz',
      'component': WelcomeQuiz,
      'name' : 'welcomeQuiz',
      meta: {title: 'Bem-vindo'}
    },
    {
      'path': '/profile',
      'component': Profile,
      'name' : 'profile',
      meta: {title: 'Perfil'}
    },
    {
      'path': '/gravarTreino',
      'component': GravarTreino,
      'name' : 'gravarTreino',
      meta: {title: 'Gravar Treino'}
    },
    {
      'path': '/noticias',
      'component': Noticias,
      'name' : 'noticias',
      meta: {title: 'Noticias'}
    },
    {
      'path': '/findFriends',
      'component': FindFriends,
      'name' : 'findFriends',
      meta: {title: 'Encontrar Atletas'}
    },
    {
      'path': '/meusAlunos',
      'component': MeusAlunos,
      'name' : 'meusAlunos',
      meta: {title: 'Meus Alunos'}
    },
    {
      'path': '/treinosDoDia',
      'component': TreinosDoDia,
      'name' : 'TreinosDoDia',
      meta: {title: 'Treinos do dia'}
    },
    {
      'path': '/admin/treinosDoDia',
      'component': TodosOsTreinosDoDia,
      'name' : 'TodosOsTreinosDoDia',
      meta: {title: 'Todos os treinos do dia'}
    },
    {
      'path': '/admin/treinos',
      'component': TodosOsTreinos,
      'name' : 'TodosOsTreinos',
      meta: {title: 'Todos os treinos'}
    },
    {
      'path': '/eventos',
      'component': Eventos,
      'name' : 'eventos',
      meta: {title: 'Eventos'}
    },
    {
      'path': '/novaConta',
      'component': NovaConta,
      'name' : 'novaConta',
      meta: {title: 'Criar Conta'}
    },
    {
      'path': '/planos',
      'component': Planos,
      'name' : 'planos',
      meta: {title: 'Planos'}
    },
    {
      'path': '/assinatura',
      'component': Assinatura,
      'name' : 'assinatura',
      meta: {title: 'Assinaturas'}
    },
    {
      'path': '/minhasAssinaturas',
      'component': MinhasAssinaturas,
      'name' : 'minhasAssinaturas',
      meta: {title: 'Minhas Assinaturas'}
    },
    {
      'path': '/alunos',
      'component': Alunos,
      'name' : 'alunos',
      meta: {title: 'Alunos'}
    },
    {
      'path': '/reports',
      'component': ReportPage,
      'name' : 'reports',
      meta: {title: 'Relatórios'}
    },
    {
      'path': '/chartPageAdmin',
      'component': ChartPageAdmin,
      'name' : 'chartPageAdmin',
      meta: {title: 'Gráficos'}
    },
    {
      'path': '/globalInsights',
      'component': GlobalInsights,
      'name' : 'globalInsights',
      meta: {title: 'Insights'}
    },
    {
      'path': '/specificInsights',
      'component': SpecificInsights,
      'name' : 'specificInsights',
      meta: {title: 'Insights'}
    },
    {
      'path': '/chartPageAluno',
      'component': ChartPageAluno,
      'name' : 'chartPageAluno',
      meta: {title: 'Gráficos'}
    },
    {
      'path': '/givenFeedbacks',
      'component': GivenFeedbacks,
      'name' : 'givenFeedbacks',
      meta: {title: 'Feedbacks'}
    },
    {
      'path': '/dailyResume',
      'component': DailyResume,
      'name' : 'dailyResume',
      meta: {title: 'Resumo do Dia'}
    },
    {
      'path': '/users',
      'component': Users,
      'name' : 'users',
      meta: {title: 'Usuários do Sistema'}
    },
    {
      'path': '/alunoResumo',
      'component': AlunoResumo,
      'name' : 'alunoResumo',
      meta: {title: 'Meu Resumo'}
    },
    {
      'path': '/removerConta',
      'component': RemoverConta,
      'name' : 'removerConta',
      meta: {title: 'Remover Conta'}
    },
    {
      'path': '/meusAlunosResumo',
      'component': MeusAlunosResumo,
      'name' : 'meusAlunosResumo',
      meta: {title: 'Resumo dos Alunos'}
    },
  ]
})
